<template>
  <el-col :span="span">
    <span v-if="!editing">{{taxType.toUpperCase()}} {{value}}%</span>
    <el-input
      size="small"
      v-model.number="value"
      v-if="editing"
      :controls="false"
      :max="100"
      :min="0"
    >
      <template slot="append">
        <el-button
          icon="el-icon-check"
          size="small"
          @click="editing = false; updateTax()"
        ></el-button>
        <el-button
          icon="el-icon-close"
          size="small"
          @click="editing = false"
        ></el-button>
      </template>
    </el-input>
    <el-button
      v-if="!editing && $isFullAdmin"
      icon="el-icon-edit"
      size="small"
      @click="editing = true"
    ></el-button>
  </el-col>
</template>

<script>
export default {
  name: "tax-input",
  props: {
    taxType: {
      type: String,
      required: true
    },
    tax: {
      type: Number,
      required: true
    },
    span: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      value: this.tax,
      editing: false
    };
  },
  methods: {
    updateTax() {
      this.value = +(Math.round(this.value + "e+2") + "e-2");
      this.$emit("update", { value: this.value, type: this.taxType });
    }
  },
  watch: {
    value: function(val) {
      if (this.value > 100) {
        this.value = 100;
      }
      if (this.value < 0) {
        this.value = 0;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// ClientApp/app/masters/canadiantaxes/components/TaxInput.vue